import { Interpreter, State } from 'xstate'

import { Applicant, PublicApplicationData } from '@flatsy/types/Applications'

import { WizardContext, WizardEvent } from './wizardMachine'

export interface ContextProps {
  children: any
}
export type WizardContextState = State<
  WizardContext,
  WizardEvent,
  any,
  {
    value: any
    context: WizardContext
  }
>
export type WizardServiceInterpreter = Interpreter<
  WizardContext,
  any,
  WizardEvent,
  {
    value: any
    context: WizardContext
  }
>
export interface ReturnContextProps {
  paramsUrl: {
    applicationId?: string
    id?: string
  }
  wizardContext: WizardContextState
  wizardService: WizardServiceInterpreter
  saveApplicationInRedux: (application: PublicApplicationData) => void
  saveApplicationAndContinue: (application: PublicApplicationData) => void
  saveApplicantAndContinue: (applicantContext: Applicant, applicant: Partial<Applicant>) => void
  nextStep: () => void
  previousStep: () => void
  getCurrentStepTitle: () => string
  includeBenefits: boolean
  isPinel: boolean
  loading: boolean
  inWaitingList: boolean
}

export enum WizardScreen {
  bookingSelector = 'booking.booking_selection',
  noBookableSlot = 'booking.no_bookable_slot',
  closed = 'closed',
  projectRent = 'project.rent',
  projectSale = 'project.sale',
  projectPro = 'project.pro',
  applicantMain = 'applicant.main_applicant',
  applicantCoCandidat = 'applicant.co_candidat',
  verlingueGuarantor = 'applicant.verlingue_guarantor',
  needGuarantor = 'applicant.need_guarantor',
  guarantor = 'applicant.guarantor',
  professional = 'applicant.professional',
  success = 'result.success',
  failed = 'result.refused',
  slotAlreadyTaken = 'result.slot_already_taken',
  end = 'end',
}
